import { formatAppRouter } from '@Core/Helpers/System'
import { dashboardCrmRouterConfig } from './Modules/Dashboard/configs/router'
import dashboardCrmNavigationConfig from './Modules/Dashboard/configs/navigation'
import marketingCrmNavigationConfig from './Modules/Marketing/configs/navigation'
import { marketingCrmRouterConfig } from './Modules/Marketing/configs/router'

export const crmNavigationConfig = [dashboardCrmNavigationConfig, marketingCrmNavigationConfig]

export const crmRouterConfig = formatAppRouter([dashboardCrmRouterConfig, marketingCrmRouterConfig])
